import React, { useState } from 'react'
import { Form } from 'react-router-dom'
import { barely, reciept_header, Footer_img, barely_black_bg_img } from '../../../public/LoginImages/importimages'
import { apiurl } from '../../../path'
import { usePDF } from 'react-to-pdf';
import './innercss.css'
const RecieptForm = () => {
    const [form, setform] = useState({
        PAN_No: "",
        GST_No: "",
        txnid:""
    })
    const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });
    const [Table, SetTable] = useState([])
    const [searchdata, setSearchdata] = useState([])
    const [hide, Sethide] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = Table?.slice(indexOfFirstItem, indexOfLastItem);
    const [loading, setloading] = useState(false)

    const handlechange = (e) => {
        setform({ ...form, [e.target.id]: e.target.value })
    }

    const [paymentdata, Setpaymentdata] = useState({})

    async function Submit() {
        
        Sethide(true)
        setloading(true)
        try {
            let data = await fetch(
                `${apiurl}/BidderRegister/Reciept`,
                {
                    method: 'post',
                    headers: ({ 'Content-Type': 'Application/json' }),
                    body: JSON.stringify({ ...form })
                })
            data = await data.json()
            console.log(data)
            setSearchdata(data)
            if (data === false) {
                Sethide(false)
                setloading(false)
                return alert('incorrect GST or Pan or TXN ID')
            }
            else {
                SetTable(data)
                setloading(false)
            }
        } catch (error) {
            console.error('Error in Submit:', error);
        }

    }


    const search = (e) => {
        try {
            let searchValue = e.target.value.toLowerCase();

            if (!searchValue) {
                SetTable(searchdata); // If search value is empty, show all data
                return;
            }

            let newdata = searchdata.filter((item) => {
                // Check for a match in multiple fields
                return (
                    item.id.toString().includes(searchValue) ||
                    item.ErnestMoneyDeposit.toString().includes(searchValue) ||
                    item.TenderFee.toString().includes(searchValue) ||
                    item.net_amount_debit.toString().includes(searchValue)
                );
            });

            SetTable(newdata);
            console.log(newdata);
        } catch (error) {
            console.error('Error in search:', error);
        }
    }

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <>
            <div id='tablesdata' style={{ justifyContent: 'center', display: 'grid', alignItems: 'center', height: '100vh', backgroundImage: `url(${barely_black_bg_img})`, backgroundSize: "cover" }}>

                <div className="card-body">
                    <Form hidden={hide} className='searchTender' onSubmit={Submit} style={{ background: "linear-gradient(rgba(255,255,255,0.8),rgba(255,255,255,0.8))", borderRadius: '1rem', padding: '2rem', height: "70%" }}>
                        <h3 style={{ textAlign: "center" }}>Receipt</h3>
                        <hr></hr>
                        <div className="mb-3">
                            <label htmlFor="exampleInputEmail1" className="form-label"><b>GST Number</b></label>
                            <input type="text" className="form-control" id="GST_No" value={form.GST_No} onChange={(e) => handlechange(e)} aria-describedby="emailHelp" required />
                            <div id="emailHelp" className="form-text">We'll never share your GST no. with anyone else.</div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="exampleInputPassword1" className="form-label"><b>Pan number</b></label>
                            <input type="text" className="form-control" value={form.PAN_No} id="PAN_No" required onChange={(e) => handlechange(e)} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="exampleInputPassword1" className="form-label"><b>Transaction ID</b></label>
                            <input type="text" className="form-control" value={form.txnid} id="txnid" required onChange={(e) => handlechange(e)} />
                        </div>
                        <div className="mb-3 form-check">
                            <input type="checkbox" className="form-check-input" id="exampleCheck1" required />
                            <label className="form-check-label" htmlFor="exampleCheck1">Check me out</label>
                        </div>
                        <div style={{ display: "grid", justifyContent: "center" }}>
                            <button type="submit" className="btn btn-success">Submit</button>
                        </div>
                    </Form>
                </div>



                {
                    loading ? (
                        <div className='loader'></div>
                    ) : (
                        <div hidden={!hide} style={{ overflow: "auto", background: "transparent", border: "none" }} className="card" >
                            <span style={{ display: "flex", justifyContent: "center" }}>
                                <input className='form-control' type='search' placeholder='Search Reciept by ID or EMD or Tender_Fee or Net_Amount ' onChange={(e) => { search(e) }} />
                            </span>

                            <table className="card-body table table-dark" style={{ marginTop: '20px', border: '1px solid black' }}>
                                <thead>
                                    <tr style={{ backgroundColor: 'lightblue' }}>
                                        <th>Reciept</th>
                                        <th>Sr.No.</th>
                                        <th>First Name</th>
                                        <th>Email</th>
                                        <th>GST No</th>
                                        <th>PAN No</th>
                                        <th>Gst Amount</th>
                                        <th>Ernest Money Deposit</th>
                                        <th>Scheme Fee</th>
                                        <th>Net Amount Debit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.map((e, index) => (
                                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? 'lightgray' : 'white' }}>
                                            <td><button className='btn btn-success' onClickCapture={(x) => Setpaymentdata(e)} onClick={(x) => { Setpaymentdata(e); document.getElementById('reciept').style.display = 'grid'; document.getElementById('tablesdata').style.display = 'none' }}>Reciept</button></td>
                                            <td>{index+1}</td>
                                            <td>{e.firstname}</td>
                                            <td>{e.Email||e.email}</td>
                                            <td>{e.GST_No}</td>
                                            <td>{e.PAN_No||e.Organisation_ID}</td>
                                            <td>{e.GstAmount||e.GSTAMOUNT}</td>
                                            <td>{e.ErnestMoneyDeposit}</td>
                                            <td>{e.TenderFee}</td>
                                            <td>{e.net_amount_debit}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )
                }

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <ul className="pagination">
                        {Array(Math.ceil(Table?.length / itemsPerPage))
                            .fill()
                            .map((_, index) => (
                                <li key={index} className="page-item">
                                    <button onClick={() => paginate(index + 1)} className="page-link">
                                        {index + 1}
                                    </button>
                                </li>
                            ))}
                    </ul>
                </div>


            </div>
            <div id='reciept' ref={targetRef} style={{ display: 'none', justifyContent: 'center' }} >
                <div className="card mb-3">
                    <img src={reciept_header} className="card-img-top" alt="..." style={{ width: '100%' }} />
                    <div className="card-body d-flex" style={{ justifyContent: 'space-between' }}>
                        <span className='w-50' style={{ textAlign: 'left' }} >
                        <h6 className="">Scheme Name: {paymentdata.Tender_Name}</h6>
                        <h6 className="">Description: {paymentdata.Description}</h6>                  
                            <h6 className="">Name: {paymentdata.Bidder_CompanyName||paymentdata.firstname}</h6>
                            <h6 className="">Email: {paymentdata.Email||paymentdata.email}</h6>
                        </span>
                        <span className='w-50' style={{ textAlign: 'right' }}>
                            <h6 className="">Transaction ID: {paymentdata.easepayid}</h6>
                            <h6 className="">Date: {paymentdata.addedon}</h6>
                            <h6 className="">GST No: {paymentdata.GST_No}</h6>
                            {/* <h6 className="my-3">Payment Status: {paymentdata.status}</h6> */}
                            {
                                paymentdata.status=="success"? <h6 className="my-3">Payment Status: Success</h6>:<h6 className="my-3">Payment Status: Pending</h6>
                            }
                        </span>
                    </div>
                    <div className="card" style={{ width: "100%" }}>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item" style={{ display: 'flex', backgroundColor: 'red', color: 'white' }}>
                                <span style={{ width: '33%', textAlign: 'center' }}>Sr no</span>
                                <span style={{ width: '33%', textAlign: 'center' }}>Particulars</span>
                                <span style={{ width: '33%', textAlign: 'center' }}>Amount</span>
                            </li>
                            <li className="list-group-item" style={{ display: 'flex' }}>
                                <span style={{ width: '33%', textAlign: 'center' }}>1</span>
                                <span style={{ width: '33%', textAlign: 'center' }}>Emd Fee</span>
                                <span style={{ width: '33%', textAlign: 'center' }}>{paymentdata.ErnestMoneyDeposit}</span>
                            </li>
                            <li className="list-group-item" style={{ display: 'flex' }}>
                                <span style={{ width: '33%', textAlign: 'center' }}>2</span>
                                <span style={{ width: '33%', textAlign: 'center' }}>Scheme Fee</span>
                                <span style={{ width: '33%', textAlign: 'center' }}>{paymentdata.TenderFee}</span>
                            </li>
                            <li className="list-group-item" style={{ display: 'flex' }}>
                                <span style={{ width: '33%', textAlign: 'center' }}>3</span>
                                <span style={{ width: '33%', textAlign: 'center' }}>Gst Amount</span>
                                <span style={{ width: '33%', textAlign: 'center' }}>{paymentdata.GstAmount||paymentdata.GSTAMOUNT} </span>
                            </li>
                            <li className="list-group-item" style={{ display: 'flex', fontWeight: "bold" }}>
                                <span style={{ width: '33%', textAlign: 'center' }}>4</span>
                                <span style={{ width: '33%', textAlign: 'center' }}>Total Amount</span>
                                <span style={{ width: '33%', textAlign: 'center' }}>{paymentdata.PaymentAmount||paymentdata.net_amount_debit}</span>
                            </li>
                        </ul>
                        <div className='my-5' style={{ display: 'grid', justifyContent: 'center', width: "90vw", textAlign: "center" }}>
                            <div>
                                <h3>Declaration:</h3>
                                <p>
                                    Certified that the particulars given in invoice are true & correct and the amount represents indicates
                                    the actual price charged and that there is no additional flow of consideration directly from
                                    the Bareily Nigam
                                </p>
                            </div>
                        </div>



                        <div className="card mb-3" style={{ border: "none" }}>
                            <img src={Footer_img} className="card-img-top" alt="..." style={{ width: '100%' }} />
                        </div>
                        <button onClick={() => { toPDF() }} className='btn btn-success'>print</button>      
                    </div>
                </div>
            </div>
        </>
    )
}

export default RecieptForm